// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var ListTriggersRequest_SortOptions;
(function (ListTriggersRequest_SortOptions) {
    ListTriggersRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListTriggersRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListTriggersRequest_SortOptions["DELETED_AT"] = "DELETED_AT";
    ListTriggersRequest_SortOptions["TRIGGER_AT"] = "TRIGGER_AT";
})(ListTriggersRequest_SortOptions || (ListTriggersRequest_SortOptions = {}));
export var ListTriggersRequest_SortOptions_index;
(function (ListTriggersRequest_SortOptions_index) {
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["DELETED_AT"] = 2] = "DELETED_AT";
    ListTriggersRequest_SortOptions_index[ListTriggersRequest_SortOptions_index["TRIGGER_AT"] = 3] = "TRIGGER_AT";
})(ListTriggersRequest_SortOptions_index || (ListTriggersRequest_SortOptions_index = {}));
export const MetlAmpService = {
    /**
     * TriggerFilterOptions returns valid filter options for a Location and the provided source_tenant_ids.
     */
    TriggerFilterOptions(fn, req) {
        return fn(`/messaging/etl/amp/v1/triggers/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ActiveTriggerTypes returns a list of active trigger types for the provided location and source tenants.
     * A trigger is active when there are records synced for that trigger type.
     */
    ActiveTriggerTypes(fn, req) {
        return fn(`/messaging/etl/amp/v1/triggers/active?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetLocations returns all active locations by org id.
     */
    GetLocations(fn, req) {
        return fn(`/messaging/etl/amp/v1/locations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetMessagesSent returns counts of messages sent by message type in the last 30 days.
     * this overview is available for all message types
     */
    GetMessagesSent(fn, req) {
        return fn(`/messaging/etl/amp/v1/attribution/messages-sent?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetAppointmentsScheduled returns counts of appointments scheduled in the last 30 days by message type received in the 30 day window prior to the appointment being scheduled.
     * AttributionType: APPOINTMENTS_SCHEDULED
     */
    GetAppointmentsScheduled(fn, req) {
        return fn(`/messaging/etl/amp/v1/attribution/appointments-scheduled?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetAppointmentsConfirmed returns counts of successful appointment confirmation writebacks in the last 30 days by message type.
     * AttributionType: APPOINTMENTS_CONFIRMED
     */
    GetAppointmentsConfirmed(fn, req) {
        return fn(`/messaging/etl/amp/v1/attribution/appointments-confirmed?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetAppointmentsCompleted returns counts of appointments completed in the last 30 days by message type received in the 30 day window prior to the appointment being completed.
     * AttributionType: APPOINTMENTS_COMPLETED
     */
    GetAppointmentsCompleted(fn, req) {
        return fn(`/messaging/etl/amp/v1/attribution/appointments-completed?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetMessagesReplied returns counts of message replies occurring within 24 hours of messages sent for the last 30 days by message type.
     * AttributionType: MESSAGES_REPLIED
     */
    GetMessagesReplied(fn, req) {
        return fn(`/messaging/etl/amp/v1/attribution/messages-replied?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
